class TrGridSwitch extends HTMLElement {
	selectors = {
		button: '[data-tr-js-grid-switch-button]'
	};

	attributes = {
		targetId: 'data-tr-js-grid-switch-target-id',
		containerId: 'data-tr-js-grid-switch-container-id',
		columnsDesktop: 'data-tr-js-grid-switch-columns-desktop',
		columnsMobile: 'data-tr-js-grid-switch-columns-mobile'
	};

	stateClasses = {
		isActive: 'is-active'
	};

	connectedCallback() {
		this.buttonElements = Array.from(this.querySelectorAll(this.selectors.button));
		this.targetId = this.getAttribute(this.attributes.targetId);
		this.containerId = this.getAttribute(this.attributes.containerId);
		this.targetElement = this.getTargetElement();
		this.targetContainerElement = this.getTargetContainerElement();

		this.init();
		this.bindEvents();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);

		this.destroy();
	}

	init() {
		if (this.observer) this.observer.disconnect();

		this.observer = null;
		this.targetElement = this.getTargetElement();
		this.targetContainerElement = this.getTargetContainerElement();
		this.activeButtonElement =
			this.buttonElements.find(
				(buttonElement) => buttonElement.getAttribute('aria-pressed') === 'true'
			) || this.buttonElements[0];

		if (this.targetContainerElement) {
			this.observer = new MutationObserver(this.onTargetContainerChange);
			this.observer.observe(this.targetContainerElement, {
				childList: true,
				subtree: true
			});
		}

		if (this.activeButtonElement) this.activateButton(this.activeButtonElement);
	}

	bindEvents() {
		this.buttonElements.forEach((buttonElement) => {
			buttonElement.addEventListener('click', this.onButtonClick);
		});
	}

	onButtonClick = (event) => {
		this.activateButton(event.currentTarget);
	};

	onTargetContainerChange = () => {
		this.targetElement = this.getTargetElement();
		this.applyGridColumns();
	};

	onSectionLoad = (event) => {
		if (
			!this.closest(`#${event.detail.sectionId}`) &&
			!this.closest(`#shopify-section-${event.detail.sectionId}`)
		)
			return;

		this.init();
	};

	activateButton(buttonElement) {
		this.activeButtonElement = buttonElement;

		this.buttonElements.forEach((element) => {
			const isActive = element === buttonElement;

			element.classList.toggle(this.stateClasses.isActive, isActive);
			element.setAttribute('aria-pressed', String(isActive));
		});

		this.applyGridColumns();
	}

	applyGridColumns() {
		if (!this.targetElement || !this.activeButtonElement) return;

		const columnsDesktop = this.activeButtonElement.getAttribute(
			this.attributes.columnsDesktop
		);
		const columnsMobile = this.activeButtonElement.getAttribute(
			this.attributes.columnsMobile
		);

		if (columnsDesktop) {
			this.targetElement.style.setProperty(
				'--trGridSwitchColumnsDesktop',
				columnsDesktop
			);
		}

		if (columnsMobile) {
			this.targetElement.style.setProperty(
				'--trGridSwitchColumnsMobile',
				columnsMobile
			);
		}
	}

	getTargetElement() {
		if (!this.targetId) return null;

		return document.getElementById(this.targetId);
	}

	getTargetContainerElement() {
		if (this.containerId) return document.getElementById(this.containerId);

		if (this.targetElement) return this.targetElement.parentElement;

		return null;
	}

	destroy() {
		this.buttonElements.forEach((buttonElement) => {
			buttonElement.removeEventListener('click', this.onButtonClick);
		});

		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}
	}
}

if (!customElements.get('tr-grid-switch')) {
	customElements.define('tr-grid-switch', TrGridSwitch);
}
